import { LucideIcon, TrendingUp, TrendingDown } from "lucide-react";
import clsx from "clsx";

interface Props {
  icon: LucideIcon;
  label: string;
  value: React.ReactNode;
  delta?: number;
  hint?: string;
  tone?: "info" | "success" | "warning" | "danger" | "neutral";
}

const TONE: Record<string, string> = {
  info:    "bg-brand-100 text-brand-700",
  success: "bg-success-100 text-success-700",
  warning: "bg-warning-100 text-warning-700",
  danger:  "bg-danger-100 text-danger-700",
  neutral: "bg-surface-100 text-surface-700",
};

export function MetricCard({ icon: Icon, label, value, delta, hint, tone = "neutral" }: Props) {
  return (
    <div className="card-elevated p-5">
      <div className="flex items-start justify-between">
        <div className={clsx("h-10 w-10 rounded-lg grid place-items-center", TONE[tone])}>
          <Icon className="h-5 w-5" />
        </div>
        {typeof delta === "number" && (
          <div className={clsx(
            "flex items-center gap-1 text-xs font-semibold",
            delta >= 0 ? "text-success-700" : "text-danger-700",
          )}>
            {delta >= 0 ? <TrendingUp className="h-3.5 w-3.5" /> : <TrendingDown className="h-3.5 w-3.5" />}
            {Math.abs(delta).toFixed(1)}%
          </div>
        )}
      </div>
      <div className="mt-4 text-2xs uppercase tracking-wide text-surface-500 font-semibold">{label}</div>
      <div className="mt-1 text-2xl font-bold text-surface-900">{value}</div>
      {hint && <div className="mt-0.5 text-xs text-surface-500">{hint}</div>}
    </div>
  );
}
